import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import appsLibraryService from "@/services/appLibrary";

export const useAppsStore = defineStore("apps", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchAppsLibrary(companyId) {
    loading.value = true;
    try {
      const res = await appsLibraryService.getAppsLibrary(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addApp(payload) {
    loading.value = true;
    try {
      const res = await appsLibraryService.addApp(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editApp(payload) {
    loading.value = true;
    try {
      const res = await appsLibraryService.editApp(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteApp(payload) {
    loading.value = true;
    try {
      const res = await appsLibraryService.deleteApp(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchAppsLibrary,
    addApp,
    editApp,
    deleteApp,
  };
});
